module.exports = __webpack_public_path__ + "img/38_10.a165404b.png";